import React from 'react'
import { Form, Input } from 'antd';
import FormControls from '../../../../../components/form/FormControls/FormControls';

type LevelFormInputsProps = {
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    clearForm?: () => void
    resetChanges?: () => void
    submitForm: () => void
}

export const LevelFormInputs: React.FC<React.PropsWithChildren<LevelFormInputsProps>> = (props) => {
    const {
        handleChange, clearForm, submitForm,
        resetChanges,
    } = props

    return (
        <>
            <Form.Item
                name="name"
                label="Название сложности"
                className="uif-ant-form-item"
            >
                <Input onInput={handleChange} />
            </Form.Item>

            <FormControls
                submitForm={submitForm}
                resetChanges={resetChanges}
                clearForm={clearForm}
            />
        </>
    )
}

export default LevelFormInputs